import type { BatchDetailResponse } from "../../gen/models";

export type BatchTab = "changeset" | "conversations" | "comments" | "evaluations";

interface BatchDetailTabsHeaderProps {
  activeTab: BatchTab;
  onTabChange: (tab: BatchTab) => void;
  batch: BatchDetailResponse | null;
}

export function BatchDetailTabsHeader({
  activeTab,
  onTabChange,
  batch,
}: BatchDetailTabsHeaderProps) {
  const draftRulesCount = batch?.draft_rules?.length || 0;
  const draftKnowledgeCount = batch?.draft_knowledge_items?.length || 0;
  const draftGuardrailsCount = batch?.draft_guardrails?.length || 0;
  const totalChangesCount = draftRulesCount + draftKnowledgeCount + draftGuardrailsCount;

  const conversationsCount = batch?.threads_count ?? batch?.threads?.length ?? 0;
  const commentsCount = batch?.comments?.length || 0;
  const evaluationsCount = batch?.evaluations?.length || 0;

  return (
    <div className="px-5 border-b border-stone-200 dark:border-stone-800 flex items-center gap-6 text-xs font-semibold shrink-0 bg-white dark:bg-stone-900">
      <button
        type="button"
        onClick={() => onTabChange("changeset")}
        className={`py-3 border-b-2 transition cursor-pointer ${
          activeTab === "changeset"
            ? "border-emerald-600 text-emerald-700 dark:text-emerald-400"
            : "border-transparent text-stone-500 hover:text-stone-800 dark:hover:text-stone-200"
        }`}
      >
        {batch?.status === "completed" ? "Created Rules & Knowledge" : "Proposed Changeset"} ({totalChangesCount})
      </button>
      <button
        type="button"
        onClick={() => onTabChange("conversations")}
        className={`py-3 border-b-2 transition cursor-pointer ${
          activeTab === "conversations"
            ? "border-emerald-600 text-emerald-700 dark:text-emerald-400"
            : "border-transparent text-stone-500 hover:text-stone-800 dark:hover:text-stone-200"
        }`}
      >
        Linked Conversations ({conversationsCount})
      </button>
      <button
        type="button"
        onClick={() => onTabChange("comments")}
        className={`py-3 border-b-2 transition cursor-pointer ${
          activeTab === "comments"
            ? "border-emerald-600 text-emerald-700 dark:text-emerald-400"
            : "border-transparent text-stone-500 hover:text-stone-800 dark:hover:text-stone-200"
        }`}
      >
        Conversation Comments ({commentsCount})
      </button>
      <button
        type="button"
        onClick={() => onTabChange("evaluations")}
        className={`py-3 border-b-2 transition cursor-pointer ${
          activeTab === "evaluations"
            ? "border-emerald-600 text-emerald-700 dark:text-emerald-400"
            : "border-transparent text-stone-500 hover:text-stone-800 dark:hover:text-stone-200"
        }`}
      >
        Linked Evaluations ({evaluationsCount})
      </button>
    </div>
  );
}
